import React from 'react';
import {
  BUSINESS_INFO,
  hasIncompleteLegalBusinessInfo,
  LEGAL_LAST_UPDATED_LABEL,
  LEGAL_TEXT_VERSION
} from '../lib/legal-config';

function LegalWarning() {
  if (!hasIncompleteLegalBusinessInfo()) {
    return null;
  }

  return (
    <p className="legal-warning">
      Attenzione: alcuni dati aziendali obbligatori sono placeholder e vanno completati prima del go-live.
    </p>
  );
}

const PrivacyPage = () => {
  return (
    <section className="legal-page">
      <h2 className="shop-title">Privacy Policy</h2>
      <p className="legal-meta">
        Versione: <strong>{LEGAL_TEXT_VERSION}</strong> | Ultimo aggiornamento: {LEGAL_LAST_UPDATED_LABEL}
      </p>
      <LegalWarning />

      <section className="legal-section">
        <h3>Titolare del trattamento</h3>
        <p>
          {BUSINESS_INFO.legalName}, {BUSINESS_INFO.address}. Email privacy: {BUSINESS_INFO.dataControllerEmail}.
        </p>
      </section>

      <section className="legal-section">
        <h3>Dati trattati</h3>
        <ul>
          <li>Dati anagrafici e di contatto forniti durante l&apos;acquisto.</li>
          <li>Dati di spedizione e storico ordini.</li>
          <li>Dati tecnici di navigazione e sicurezza.</li>
          <li>Dati analytics solo con consenso esplicito.</li>
        </ul>
      </section>

      <section className="legal-section">
        <h3>Finalita&apos; e basi giuridiche</h3>
        <ul>
          <li>Gestione ordini e spedizioni (esecuzione del contratto).</li>
          <li>Obblighi amministrativi e fiscali (obbligo legale).</li>
          <li>Difesa e sicurezza del servizio (legittimo interesse).</li>
          <li>Analisi statistiche non essenziali (consenso, revocabile).</li>
        </ul>
      </section>

      <section className="legal-section">
        <h3>Conservazione</h3>
        <p>
          I dati ordine sono conservati per i tempi richiesti dalla normativa fiscale e civilistica applicabile. I dati
          analytics sono conservati secondo le impostazioni della piattaforma analytics adottata.
        </p>
      </section>

      <section className="legal-section">
        <h3>Responsabili esterni</h3>
        <p>
          Per il funzionamento del servizio vengono utilizzati fornitori tecnici, tra cui infrastruttura cloud AWS,
          pagamenti Stripe e strumenti analytics.
        </p>
      </section>

      <section className="legal-section">
        <h3>Diritti dell&apos;interessato</h3>
        <p>
          Puoi richiedere accesso, rettifica, cancellazione, limitazione, opposizione e portabilita&apos; scrivendo a{' '}
          {BUSINESS_INFO.dataControllerEmail}.
        </p>
      </section>
    </section>
  );
};

export default PrivacyPage;
